export * from './panel.component';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/shared/panel/index.ts